/* @flow */
import * as React from "react";
import type { StylesObject } from "../utils/prefixStyles";
import Heading from "../Heading";
import Item, { type Props as ItemProps } from "./Item";
import Divider from "./Divider";

type Props = {
  showDividers?: ?boolean,
  items: Array<ItemProps>,
  style?: ?StylesObject,
  title?: ?string,
  id: string, // for end-to-end testing
  itemsWrapperProps?: ?React.ElementConfig<"div">,
};

export default class ItemList extends React.Component<Props> {
  render() {
    const {
      showDividers,
      items: itemsFromProps,
      style,
      title,
      id,
      itemsWrapperProps,
    } = this.props;
    const items = [];
    itemsFromProps.forEach((item, index) => {
      const { children, id: itemId, ...itemProps } = item;
      const showBottomLine =
        showDividers && index !== itemsFromProps.length - 1;
      items.push(
        <Item key={itemId} id={itemId} {...itemProps}>
          {children}
        </Item>
      );
      if (showBottomLine) {
        items.push(<Divider key={`${itemId}-hr`} />);
      }
    });

    return (
      <div
        data-component-name="ItemList"
        data-component-prop-title={title}
        data-component-prop-id={id}
        style={style}
      >
        {title ? <Heading label={title} /> : null}
        {itemsWrapperProps == null ? (
          items
        ) : (
          <div {...itemsWrapperProps}>{items}</div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/ItemList/ItemList.jsx